/**
 * The assembled registries, set once at startup by `app/registry/index.ts` (which imports the built-ins) and read
 * by anything that needs them at run time. Keeping the holder separate avoids an import cycle between the built-in
 * definitions and the assembler.
 */
import type { Registries } from './define';

let current: Registries | null = null;

export function setRegistries(r: Registries): void {
  current = r;
}

export function registries(): Registries {
  if (!current) throw new Error('registries() before app/registry/index.ts assembled them');
  return current;
}
